import { ALLOWED_SITE_LANGUAGES, DEFAULT_LANGUAGE, LOCALE_MAP } from '../../utils';

export const FAQ_VIDEO_EMBED = 'https://www.youtube.com/embed/KgDDCC6QKeI?si=LO-vK9pOfAj3Z4yt';

/** Served from `public/video`; one `<base>.<locale>.vtt` per site language. */
export const FAQ_CAPTIONS_BASE = '/video/Leading-With-Character-FAQ';

export interface Cue {
  start: number;
  end: number;
  text: string;
}

const siteLocale = (locale: string): string => (ALLOWED_SITE_LANGUAGES.includes(locale) ? locale : DEFAULT_LANGUAGE);

/** `hl` = player UI locale; `cc_lang_pref` = ISO 639-1 track the CC button picks (no-op without that track). */
export const getFaqVideoUrl = (locale: string): string => {
  const current = siteLocale(locale);
  const [language, region] = current.split('-');
  const hl = region ? `${language}-${region.toUpperCase()}` : language;
  return `${FAQ_VIDEO_EMBED}&enablejsapi=1&hl=${hl}&cc_lang_pref=${LOCALE_MAP[current]}`;
};

export const getFaqCaptionsUrl = (locale: string): string => `${FAQ_CAPTIONS_BASE}.${siteLocale(locale)}.vtt`;

const toSeconds = (stamp: string): number => stamp.split(':').reduce((total, part) => total * 60 + Number(part), 0);

/** Reads cue timings and text only; cue settings, NOTE and STYLE blocks are ignored. */
export const parseVtt = (vtt: string): Cue[] => vtt.replace(/\r/g, '').trim().split(/\n{2,}/).flatMap((block) => {
  const lines = block.split('\n');
  const timing = lines.findIndex((line) => line.includes('-->'));
  if (timing < 0) { return []; }
  const [start, end] = lines[timing].split('-->').map((part) => toSeconds(part.trim().split(/\s+/)[0]));
  return [{ start, end, text: lines.slice(timing + 1).join('\n') }];
});

export const getCueText = (cues: Cue[], time: number): string => (
  cues.find(({ start, end }) => time >= start && time < end)?.text ?? ''
);
